import ApiProxy from "../../ts/ApiProxy";

type DiscountListParams = {
    id?: string;
    name: string;
    value: number;
};
type DiscountCouponId = { id: number };
type SportsVoucherId = { id: number };
interface DiscountListRequestParams {
    id: string;
    discountCouponIds: DiscountCouponId[];
    sportsVoucherIds: SportsVoucherId[];
    isPoint: boolean;
};
export type DiscountResponseItem = {
    type?: DiscountItemType;
    name: string;
    value: number;
};
enum DiscountItemType {
    coupon = "coupon",
    sportsVoucher = "sportsVoucher",
    point = "point"
};

export default class DisocuntList {
    discountList: DiscountListParams[];

    constructor(discountList: DiscountListParams[] = []) {
        this.discountList = discountList;
    }

    /** 取得優惠加總 */
    getSum(): number {
        let sum = 0;
        this.discountList.forEach((item) => {
            sum += item.value;
        });
        return sum;
    }
    /** 取得優惠加總不包刮點數 */
    getSumNotPoint(): number {
        let sum = 0;
        this.discountList.forEach((item) => {
            if (item.id !== DiscountItemType.point)
                sum += item.value;
        });
        return sum;
    }
    /** 取得資料筆數 */
    getCount(): number {
        let count = 0;
        this.discountList.forEach((item) => {
            if (item.value > 0) count++;
        });
        return count;
    }
    /** 取得HTML */
    getHtml(template: any): string {
        return template({ discounts: this.discountList });
    }
    /** 取得優惠類型 */
    getTyepEumns() {
        return DiscountItemType;
    }
    /** 依照優惠類型覆寫新資料 */
    setByType(name: string, value: number, type?: DiscountItemType) {
        let obj: DiscountListParams = { id: type, name: name, value: value };
        if (type) {
            let obj = this.discountList.find((item) => item.id === type)
            if (obj) {
                obj.name = name;
                obj.value = value;
                return this;
            }
        }
        this.discountList.push(obj);
        return this;
    }
    /** DiscountResponseItem 資料設定 */
    setList(list: DiscountResponseItem[]) {
        list.forEach((item) => {
            this.discountList.push({ id: item.type, name: item.name, value: item.value });
        });
        return this;
    }
    /** 取得點數金額 */
    getPointAmount(): number {
        let point = this.discountList.find((item) => item.id === DiscountItemType.point);
        return point ? point.value : 0;
    }
    /** 與後端取得優惠列表 */
    ajax(url: string, params: DiscountListRequestParams) {
        ApiProxy.callApi(url, params).then((response) => {
            this.discountList = [];
            response.forEach((item: DiscountResponseItem) => {
                this.discountList.push({ id: item.type, name: item.name, value: item.value });
            });
        });
        return this;
    }
    /** 以提供 Handlebars Template 覆蓋至指定 HTMLElement */
    update(root: JQuery<HTMLElement>, template: any) {
        root.empty();
        if (this.getCount() > 0)
            root.html(this.getHtml(template)).css("display", "");
        else
            root.css("display", "none");
        return this;
    }
    empty() { this.discountList = []; return this; }
}